import React, { Component } from 'react';
import { Col, Row, Card, Button, Divider, Select } from 'antd';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import qs from 'qs';

@inject('store')
@observer
export class SubscriptionOrderView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            term: 'monthly',
            paymentMethod: 'paypal',
            existingSub: null,
            legacyBot: null,
        };
    }

    async componentDidMount() {
        const parsed = qs.parse(this.props.location.search.slice(1));

        await this.props.store.billingStore.getPackages(parsed.bot_type || 'apex');
        await this.props.store.billingStore.getLegacySubscriptions();
        await this.props.store.billingStore.getBillingCountries();

        const existingSub = this.props.store.billingStore.legacySubscriptions.find(
            (sub) => (sub.id = parsed.migrate)
        );
        if (existingSub) {
            this.setState({
                existingSub,
                legacyBot: this.props.store.botStore.poolBindings[existingSub.pool_id],
            });
        }
    }

    renderCurrenyCode(product) {
        return product.currency && product.currency === 'GBP' ? '£' : '$';
    }

    async handleCompleteOrder(product, unitPrice, vat, total) {
        const { term, paymentMethod } = this.state;
        const {
            name,
            billing_name,
            address_1,
            city,
            region,
            post_code,
            country,
            vat_no,
        } = this.props.store.userStore.currentUser;
        const parsed = qs.parse(this.props.location.search.slice(1));

        await this.props.store.billingStore.createSubscription(
            parsed.package,
            product.trial ? 'trial' : term,
            product.trial ? 'trial' : paymentMethod,
            {
                name,
                billing_name,
                address_1,
                city,
                region,
                post_code,
                country,
                vat_no,
                description: `${product.name} - ${
                    product.terms[product.trial ? 'trial' : term].name
                } `,
                sub_total: unitPrice,
                vat_total: vat,
                total,
            },
            this.state.existingSub
        );
    }

    renderPaymentNotice() {
        switch (this.state.paymentMethod) {
            case 'paypal':
                return <span>You will be redirected to PayPal to complete payment</span>;
            default:
                return null;
        }
    }

    render() {
        if (!this.props.store.billingStore.countries.length) return null;

        const { currentUser } = this.props.store.userStore;
        const { timezone } = currentUser;
        const parsed = qs.parse(this.props.location.search.slice(1));

        const product = this.props.store.billingStore.packages.find(
            (p) => p.internal_id === parsed.package
        );
        const country = this.props.store.billingStore.countries.filter(
            (c) => c.code === currentUser.country
        )[0];

        const unitPrice = product.terms[product.trial ? 'trial' : this.state.term].price;
        const vat = product.trial
            ? 0
            : product.terms[this.state.term].price * (currentUser.vat_no ? 0 : country.vat_rate);
        const total = unitPrice + vat;
        const oneDay = 60000 * 60 * 24;

        return (
            <div>
                <h1>Order a Subscription</h1>

                <Row gutter={24}>
                    <Col md={10}>
                        <Card
                            title={'Billing Details'}
                            bordered={false}
                            extra={<Link to={'/a/my-account'}>Update billing details</Link>}
                        >
                            <b>Name:</b> {currentUser.billing_name || currentUser.name}
                            <br />
                            <b>Address:</b> {currentUser.address_1}
                            <br />
                            <b>City:</b> {currentUser.city}
                            <br />
                            <b>Region:</b> {currentUser.region}
                            <br />
                            <b>Post/Zip Code:</b> {currentUser.post_code}
                            <br />
                            <b>Country:</b> {currentUser.country}
                            <br />
                            <b>VAT No:</b> {currentUser.vat_no || 'None'}
                            <br />
                        </Card>
                    </Col>
                    <Col md={12}>
                        <Card title={'Subscription Details'} bordered={false}>
                            <div
                                className={
                                    'ant-table ant-table-small ant-table-scroll-position-left'
                                }
                            >
                                <div className={'ant-table-content'}>
                                    <div className={'ant-table-body'}>
                                        <table>
                                            <thead className={'ant-table-thead'}>
                                                <tr>
                                                    <th>Subscription</th>
                                                    <th>Term</th>
                                                    <th>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody className={'ant-table-tbody'}>
                                                <tr
                                                    className={
                                                        'ant-table-row ant-table-row-level-0'
                                                    }
                                                >
                                                    <td>
                                                        {product.name} -{' '}
                                                        {
                                                            product.terms[
                                                                product.trial
                                                                    ? 'trial'
                                                                    : this.state.term
                                                            ].name
                                                        }
                                                    </td>
                                                    <td>
                                                        {product.trial ? (
                                                            product.terms[
                                                                product.trial
                                                                    ? 'trial'
                                                                    : this.state.term
                                                            ].term
                                                        ) : (
                                                            <Select
                                                                value={this.state.term}
                                                                onChange={(term) => {
                                                                    this.setState({ term });
                                                                }}
                                                            >
                                                                <Select.Option value={'monthly'}>
                                                                    Monthly
                                                                </Select.Option>
                                                                <Select.Option value={'annual'}>
                                                                    Annual
                                                                </Select.Option>
                                                            </Select>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {this.renderCurrenyCode(product)}{' '}
                                                        {unitPrice.toFixed(2)}
                                                    </td>
                                                </tr>
                                                <tr
                                                    className={
                                                        'ant-table-row ant-table-row-level-0'
                                                    }
                                                >
                                                    <td>
                                                        <b>Next Charge Date: </b>
                                                        {moment(
                                                            (this.state.legacyBot &&
                                                                this.state.legacyBot.sub_expiry +
                                                                    product.terms[this.state.term] *
                                                                        oneDay) ||
                                                                new Date()
                                                        )
                                                            .tz(timezone)
                                                            .format('DD/MM/YYYY')}
                                                    </td>
                                                    <td colSpan="1" style={{ textAlign: 'right' }}>
                                                        VAT:
                                                    </td>
                                                    <td>
                                                        {this.renderCurrenyCode(product)}{' '}
                                                        {vat.toFixed(2)}
                                                    </td>
                                                </tr>
                                                <tr
                                                    className={
                                                        'ant-table-row ant-table-row-level-0'
                                                    }
                                                >
                                                    <td colSpan="2" style={{ textAlign: 'right' }}>
                                                        Total:
                                                    </td>
                                                    <td>
                                                        {this.renderCurrenyCode(product)}{' '}
                                                        {total.toFixed(2)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {parsed.migrate ? (
                                <p style={{ marginTop: 10 }}>
                                    <b>Subscription Migration:</b> When completing the order you
                                    will be charged the total above and your next charge will be on
                                    the "Next charge" date. You will then be charged every 30 days
                                    until you cancel the subscription.
                                </p>
                            ) : null}
                            <Divider />
                            <Row gutter={24}>
                                {product.trial ? null : (
                                    <Col xs={24} md={16}>
                                        <b>Payment Method:</b>&nbsp;
                                        <Select
                                            value={this.state.paymentMethod}
                                            onChange={(paymentMethod) => {
                                                this.setState({ paymentMethod });
                                            }}
                                        >
                                            <Select.Option value={'paypal'}>
                                                PayPal/Credit & Debit
                                            </Select.Option>
                                        </Select>
                                        <div>{this.renderPaymentNotice()}</div>
                                    </Col>
                                )}
                                <Col xs={24} md={8} style={{ textAlign: 'right' }}>
                                    <Button
                                        type={'primary'}
                                        size={'large'}
                                        onClick={this.handleCompleteOrder.bind(
                                            this,
                                            product,
                                            unitPrice,
                                            vat,
                                            total
                                        )}
                                    >
                                        Complete order
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/SubscriptionsView/SubscriptionOrderView.js